module.exports = __webpack_public_path__ + "static/media/contact-03.67bdf1be.png";